import { createHttpEndpoint } from '../../utils'
import type { BuybackOrderConversation } from '../models'

/**
 * Get buyback messages on a given order
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/buyback-bm-api/definition#tag/Customer/operation/get-bm-buyback-customer-orders-messages}
 */
export const getCustomerOrderMessages =
  createHttpEndpoint<BuybackOrderConversation>({
    method: 'GET',
    operationId: 'getCustomerOrderMessages',
    path: '/bm/buyback/v1/customer/orders/:id/messages',
  })
